import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { createMeasuringUnitGeneral } from '../../../services/settings/inventory';
import Button from '../../../component/ui/Button';
import Modal from '../../../component/modal/Modal';
import InputField from '../../../component/form/FormInput';

export default function AddMeasuringUnitModel({
	isOpenModel,
	setIsOpenModel,
	getList,
	setMeasuringUnitFocus,
	setMeasuringUnitOption,
	setFormData,
}) {
	const [isMeasuringUnitLoader, setMeasuringUnitLoader] = useState(false);
	const [error, setError] = useState(false);
	const [measuringUnitForm, setMeasuringUnitForm] = useState({
		id: null,
		name: '',
		short_name: '',
		is_active: true,
	});

	const handleFormData = (key, value, required) => {
		setMeasuringUnitForm((prev) => ({
			...prev,
			[key]: value,
		}));
		if (required) {
			var newError = { ...error };
			if (value === '' || value === null || value === undefined) {
				newError[key] = `Please enter valid ${key.split('-').join('')} in the field`;
			} else {
				delete newError[key];
			}
			setError(newError);
		}
	};

	function checkValidation() {
		const newError = { ...error };

		if (
			!measuringUnitForm.name ||
			measuringUnitForm.name === '' ||
			measuringUnitForm.name === undefined
		) {
			newError.name = newError.name || 'Please enter measuring unit name in the field';
		} else {
			delete newError.name;
		}

		if (Object.keys(newError).length > 0) {
			setError(newError);
			return true;
		} else {
			return false;
		}
	}

	const handleMeasuringUnit = async () => {
		let isError = checkValidation();
		if (isError) {
			return toast.error(
				`Measuring Unit ${measuringUnitForm.id !== null ? 'update' : 'create'} failed! Please fill required fields.`,
			);
		} else {
			try {
				setMeasuringUnitLoader(true);
				var body = {
					name: measuringUnitForm.name,
					short_name: measuringUnitForm.short_name,
					is_active: measuringUnitForm.is_active,
				};
				const res = await createMeasuringUnitGeneral(body);
				if (res.success) {
					const { data } = res;
					if (data?.unit.is_active) {
						setFormData((prev) => ({
							...prev,
							unit_id: data?.unit?.id || '',
						}));
						const list = [
							{
								key: data?.unit?.id || '',
								value: measuringUnitForm.name,
								short_name: measuringUnitForm.short_name,
							},
						];
						setMeasuringUnitOption(list);
					}
					getList();
					setIsOpenModel(false);
					setMeasuringUnitFocus(true);
					toast.success(res.message);
				} else {
					toast.error(res.message);
				}
			} catch (error) {
				toast.error(error.message || 'Something went wrong!');
			} finally {
				setMeasuringUnitLoader(false);
			}
		}
	};
	return (
		<Modal
			className="units_model"
			title={`${measuringUnitForm.id !== null ? 'Edit' : 'Add New'}  Measuring Unit`}
			isOpen={isOpenModel}
			onClose={() => {
				setIsOpenModel(false);
			}}
			cancelButton={() => {
				setIsOpenModel(false);
			}}
		>
			<div className="d-flex my-3 gap-2">
				<div className="col-6">
					<InputField
						label="Unit Name"
						placeholder="Unit name"
						autoFocus={true}
						type="text"
						required={true}
						value={measuringUnitForm.name}
						onChange={(value) => handleFormData('name', value)}
						error={error?.name}
					/>
				</div>
				<div className="col-6">
					<InputField
						label="Short Name"
						placeholder="Short name"
						type="text"
						required={false}
						value={measuringUnitForm.short_name}
						onChange={(value) => handleFormData('short_name', value)}
						error={error?.short_name}
					/>
				</div>
			</div>
			<div className="d-flex gap-3 align-items-center my-2">
				<div className="fs-5 fw-semibold text-dark">Active</div>
				<div className="form-check">
					<input
						class="form-check-input"
						type="checkbox"
						checked={measuringUnitForm.is_active}
						id="flexCheckDefault"
						onChange={(e) => handleFormData('is_active', !measuringUnitForm.is_active)}
					/>
				</div>
			</div>
			<div
				style={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'end',
					marginTop: '10px',
					gap: '10px',
				}}
			>
				<Button
					type="button"
					button={`Save`}
					disabled={isMeasuringUnitLoader}
					className="mt-0 px-4 btn-primary relative"
					onClick={() => handleMeasuringUnit()}
					loader={isMeasuringUnitLoader}
				/>
				<Button
					type="button"
					button={`Cancel`}
					className="mt-0 px-4 btn-gray relative"
					onClick={() => setIsOpenModel(false)}
				/>
			</div>
		</Modal>
	);
}
